import { OrdersTable } from '@root/widgets/trade/tables/orders-table'

import type { PairAddress } from '@root/entities/pair'
import type { OrdersTableModel } from '@root/widgets/trade/tables/orders-table'

type TradeOrdersTableProps = {
  pairAddress: PairAddress
  model: OrdersTableModel
}

export const TradeOrdersTable: React.FC<TradeOrdersTableProps> = ({
  model,
}) => {
  return <OrdersTable clickable={false} tableModel={model} />
}
